<google-map #map height="400px" width="100%" [center]="center" [zoom]="zoom" (mapClick)="onMapClick($event)"
    (mapMousemove)="move($event)">
    <map-marker #marker *ngFor="let markerPosition of markerPositions" [position]="markerPosition"
        [options]="markerOptions" (mapClick)="openInfoWindow(marker)"></map-marker>
    <map-info-window>{{locationModel?.locality}}</map-info-window>
</google-map>
